(function () {

    angular
        .module('app')
        .service('scratchService', scratchService);

        scratchService.$inject = [ '$http', 'qitanAiContractService' ];


    function scratchService($http, qitanAiContractService) {

        function newTfjsExtension(modelinfo) {
            var url = qitanAiContractService.getScratchApiUrl('tfjsExtensions');

            return $http.post(url, modelinfo)
                .then(function (resp) {
                    return resp.data;
                });
        }


        return {
            newTfjsExtension : newTfjsExtension
        };
    }
})();
